"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.About = void 0;
var react_1 = __importDefault(require("react"));
var About_module_scss_1 = __importDefault(require("./About.module.scss"));
var react_redux_1 = require("react-redux");
var selectors_1 = require("../../redux/selectors");
var Loader_1 = require("../../components/loader/Loader");
var BreadCrumpPage_1 = require("../../components/breadCrumpPage/BreadCrumpPage");
var About = function () {
    var about = (0, react_redux_1.useSelector)(selectors_1.aboutSelector).about;
    var isLoading = (0, react_redux_1.useSelector)(selectors_1.aboutSelector).stateLoad.isLoading;
    var error = (0, react_redux_1.useSelector)(selectors_1.aboutSelector).stateLoad.error;
    if (error) {
        return react_1.default.createElement(react_1.default.Fragment, null, "\u041E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u0434\u0430\u043D\u043D\u044B\u0445");
    }
    return (react_1.default.createElement("div", { className: "container" },
        react_1.default.createElement("div", { className: "".concat(About_module_scss_1.default.about, " page") },
            react_1.default.createElement(BreadCrumpPage_1.BreadCrumpPage, { links: [
                    { name: 'Главная', url: '/' },
                    { name: 'Об автосалоне', url: '/about' },
                ] }),
            react_1.default.createElement("h1", { className: "".concat(About_module_scss_1.default.about__title, " page__title") }, "\u041E\u0431 \u0430\u0432\u0442\u043E\u0446\u0435\u043D\u0442\u0440\u0435"),
            react_1.default.createElement("div", { className: About_module_scss_1.default.about__text }, isLoading ? (react_1.default.createElement(Loader_1.Loader, null)) : (about.map(function (item) { return (react_1.default.createElement("p", { key: item.id, className: About_module_scss_1.default.about__description }, String(item.description).replace(/\bYou-?Auto\b/gi, 'Ю-Авто'))); }))))));
};
exports.About = About;
